import React from 'react';

import style from './driverETA.module.css';

import Button from '@material-ui/core/Button';
import { createStyles, Theme, withStyles } from '@material-ui/core/styles';
import MobileStepper from '@material-ui/core/MobileStepper';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import KeyboardArrowLeft from '@material-ui/icons/KeyboardArrowLeft';
import KeyboardArrowRight from '@material-ui/icons/KeyboardArrowRight';
import SwipeableViews from 'react-swipeable-views';

import WebCamContainer from '../../dockOverloadModal/cams/WebCamsContainer';

const styles = (theme: Theme) =>

  createStyles({
    button: {
      textTransform: 'none',
      padding: '2px 20px'
    },
    root: {
      maxWidth: 400,
      flexGrow: 1
    },
    header: {
      display: 'flex',
      alignItems: 'center',
      height: 50,
      justifyContent: 'center'
    },
    carousel: {
      border: '1px solid ',
      width: '70%',
      margin: 'auto',
      marginBottom: '50px'  
    },
    img: {
      display: 'block',
      overflow: 'hidden',
      width: '100%',
      height: 'auto'
    },
    mobileStepper: {
      position: 'relative',
      background: 'transparent'
    },
    btnLeft: {
      padding: 0,
      marginLeft: '-17px',
      marginTop: '-270px'
    },
    btnRight: {
      padding: 0,
      marginRight: '-17px',
      marginTop: '-270px'
    }
  });

interface DriverETACarouselCameraProps {
  classes: any;
  activeStep: number;
  handleNext: () => void;
  handleBack: () => void;
  handleStepChange: (step: number) => void;
  cams: Array<{url: string, description: string} | null>
  ghaId: number;
};

const driverETACarouselCamera = (props: DriverETACarouselCameraProps) => {
  const camLabels = props.cams.map(c => {
    if(c && c.description)
      return c.description
    return '';
  });
  const tutorialSteps: Array<{label: string, cam: {url:string, description: string, } | null}> = [
    { label: camLabels[0], cam: props.cams[0] },
    { label: camLabels[1], cam: props.cams[1] },
    { label: camLabels[2], cam: props.cams[2] },
    { label: camLabels[3], cam: props.cams[3] }
  ];

  const { classes, activeStep } = props;
  const maxSteps = tutorialSteps.length;

  return (
    <div className={ style.carouselWrapper }>
      <Paper square elevation= {0 } className={ classes.header }>
        <Typography>{ tutorialSteps[activeStep].label }</Typography>
      </Paper>
      <SwipeableViews 
        index={ activeStep }
        onChangeIndex={ props.handleStepChange }
        className={ classes.carousel }
      >
        { tutorialSteps.map((step, index) => (
          <div key={ index }>
            { Math.abs(activeStep - index ) <= 3 ? (
              <WebCamContainer type='mobile' cam={ step.cam } ghaId={props.ghaId} />
            ) : null} 
          </div>
        ))}
      </SwipeableViews>
      <MobileStepper
        steps={ maxSteps }
        className={ classes.mobileStepper }
        variant="text"
        nextButton={
          <Button size="small" onClick={ props.handleNext } className={ classes.btnRight } disabled={ activeStep === maxSteps - 1 }>
            <KeyboardArrowRight />
          </Button>
        }
        backButton={
          <Button size="small" onClick={ props.handleBack } className={ classes.btnLeft }  disabled={ activeStep === 0 } >
            <KeyboardArrowLeft />
          </Button>
        }
      />
   </div>
  );
};

export default withStyles(styles)(driverETACarouselCamera);